import axios from '_u/axios'

// 系统词典列表
export const dictTree = (pid) => {
    return axios.post('api/sys/dict/queryDict', { pid })
}

// 词典查询
export const dictCode = (code) => {
	return axios.post('api/sys/dict/list', {
		code
	})
}

// 新增词典表记录
export const dictAdd = (body) => {
	return axios.post('api/sys/dict/add', body)
}

// 删除词典表记录
export const dictDelete = (id) => {
	return axios.post('api/sys/dict/delete', { id })
}

// 词典表明细
export const dictView = (id) => {
	return axios.post('api/sys/dict/view', { id })
}

// 更新词典记录
export const dictUpdate = (body) => {
	return axios.post('api/sys/dict/update', body)
}

// 词典排序
export const dictSort = (id, type, relativeId) => {
	return axios.post('api/sys/dict/sort', {
		id,
		type, // 操作方式 1:置顶 2:置底 3:上移或者下移
		relativeId // 相对位置数据编号,上移取其上,下移取其下,置顶置底则不传
	})
}
